module.exports = __webpack_public_path__ + "static/media/ci.387ecdfc.svg";